import { createFromIconfontCN } from '@ant-design/icons';

const MyIcon = createFromIconfontCN({
    scriptUrl: '//at.alicdn.com/t/font_3258617_qzurv9min3.js', // 在 iconfont.cn 上生成
});
export default MyIcon
